import { render } from "./app-icon-edit.vue?vue&type=template&id=3d7afc8b"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d7afc8b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d7afc8b', __exports__)) {
    console.log('reload')
    api.reload('3d7afc8b', __exports__)
  }
  
  module.hot.accept("./app-icon-edit.vue?vue&type=template&id=3d7afc8b", () => {
    console.log('re-render')
    api.rerender('3d7afc8b', render)
  })

}


export default __exports__